import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { dateShape } from '../../legacyCore/OpeningsCalendar';
import getTimeZoneFormat from '../utils/getTimeZoneFormat';
import { DATE_TIME_FORMAT } from '../constants';
import formatCalendarTime, { formatOpeningTime } from '../utils/formatCalendarTime';
import toDate from '../utils/toDate';
import { intlShape } from '../shapes';

const CalendarTime = ({ intl, datetime, timeZone }) => {
  datetime = toDate(datetime);
  return (
    <time
      dateTime={datetime && datetime.toISOString()}
      title={formatOpeningTime(datetime, intl, getTimeZoneFormat(timeZone), {
        intl: DATE_TIME_FORMAT.FULL,
        fallback: DATE_TIME_FORMAT.FULL_FALLBACK,
      })}
    >
      {formatCalendarTime(intl, datetime, { timeZone })}
    </time>
  );
};

CalendarTime.propTypes = {
  // eslint-disable-next-line react/no-typos
  intl: intlShape,
  datetime: dateShape.isRequired,
  timeZone: PropTypes.string,
};

export default injectIntl(CalendarTime);
